import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import GroheCartLoginHeader from "./groheCartLoginHeader";
import GroheCartLoginRegister from "./groheCartLoginRegister";
import {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {ROUTES} from "../../../../../routes";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import WithInputValidations from "../../../hocs/withInputValidations";
import {loginButtonCommonClick, saveQuoteAfterSignIn} from "../../../../../misc/userFunctions";

const GroheCartLogin = (props) => {

  const {isMobile, history, fabricatorSettings} = props;

  const loginButtonClick = async (updateInputValidations) => {
    const loginResponse = await loginButtonCommonClick(updateInputValidations, PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartCheckoutLogin);
    if (!loginResponse || loginResponse.error) {
      console.error("something is wrong with login response", loginResponse);
      return false
    }
    await saveQuoteAfterSignIn();
    if (!loginResponse.isPhoneNumberValidated) {
      history.push(ROUTES.cartTwoFAVerify);
    } else if (fabricatorSettings.hasPaymentGateway) {
      history.push(ROUTES.cartBilling);
    } else {
      history.push(ROUTES.cartConfirm);
    }
  }

  return (
    <WithInputValidations>
      {(inputsValidated, updateInputValidations) => {
        const stickyFooterButtons = [
          {
            translate: "buttons.back",
            classes: "look-button--secondary gc-sticky__button--20",
            onClick: () => {
              history.push(ROUTES.cart);
            }
          },
          {
            translate: "grohe.cart.login.mobile.notRegisteredButton",
            classes: "look-button--secondary gc-sticky__button--40",
            onClick: () => {
              history.push(ROUTES.cartRegister);
            }
          },
          {
            translate: "grohe.cart.login.loginButton",
            classes: "look-button--blue gc-sticky__button--40",
            onClick: () => loginButtonClick(updateInputValidations)
          }
        ];

        return (
          <div className="gc">
            <div className="gc-body">
              <GroheCartLoginHeader inputsValidated={inputsValidated}
                                    loginButtonClick={() => loginButtonClick(updateInputValidations)}/>
              {isMobile ? <div className="gc-spacer"/> : <GroheCartLoginRegister/>}
            </div>
            {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
          </div>
        )
      }}
    </WithInputValidations>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {settings} = store.fabricatorState;

  return {
    isMobile,
    fabricatorSettings: settings,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartLogin)
)
